import React from 'react';
import { Redirect } from 'expo-router';
import type { Href } from 'expo-router';
import { ActivityIndicator, View } from 'react-native';
import DashboardScreenEnhanced from '../src/screens/dashboard/DashboardScreenEnhanced';
import { useAuth } from '../src/context/AuthContext';
import { pathForPhase } from '../src/navigation/phaseRedirect';

export default function DashboardWebRoute() {
  const { phase, user } = useAuth();

  if (phase === 'loading') {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#f7f5f1' }}>
        <ActivityIndicator size="large" color="#3147b7" />
      </View>
    );
  }

  if (phase !== 'authenticated') {
    return <Redirect href={pathForPhase(phase) as Href} />;
  }

  return <DashboardScreenEnhanced user={user ?? undefined} />;
}
